// WebClient convergence services

import { FetchWrapper } from "../infrastructure/fetch-wrapper";
import { IBasicCommandResponse } from "./ah.mb.client-notifications";
import { IModelEventUserNotification } from "../components/event-notifications-editor-dialog/event-notifications-editor-dialog";

export interface IConvergeModel {
    modelId: string;
    iterations: number;
    resetType: "None" | "Warm" | "Cold";
    resourceCurvePriceIncrement: number;
    resourceCurveNumPoints: number;
    maxPrice: number;
    numCores: number;
    modelNamesToRun: Array<string>;
    scenarioNamesToRun: Array<string>;
    logConvergenceStats: boolean;
    logConvergenceRunStats: boolean;
    userNotifications: Array<IModelEventUserNotification>,
    skipValidation: boolean,
    dryRun: boolean,
    comments: string
}

export class ConvergenceServices {
    // Private declarations
    //private readonly eventObservableObj: any = null;
    private readonly hostUrl: string = null;
    private rootApiUrl = "/api/1.0/jobs";

    private convergeModelUrlPath = this.rootApiUrl;

    private cancelJobUrl = this.rootApiUrl + "/cancel";
    private deleteJobUrl = this.rootApiUrl + "/delete";

    /**
     * Ctor
     * @param {} eventObservable 
     * @returns {} 
     */
    constructor(
        //eventObservable
    ) {
        //this.eventObservableObj = eventObservable;
        this.hostUrl = "";
        //this.getHostUrl();
    }

    /**
     * Gets the convergence host url
     * @returns {} 
     */
    getHostUrl = () => {

        //                var url = this.getConvergenceHostApiUrl;

        //                $.ajax({
        //                   type: "GET",
        //   url: url,
        //   success: (data)  =>{
        //       this.hostUrl = data;
        //   },
        //   error: (data) => {
        //       this.eventObservableObj.fireEvent("serviceResponse", { success: false, response: data });
        //   }
        // });

    }

    /**
     * Checks if convergence is available
     * @returns {} 
     */
    convergenceAvailable = () => {
        return true;
        //return this.hostUrl != null;
    }

    /**
     * Converge model proc
     */
    convergeModel(value: IConvergeModel): Promise<
        IBasicCommandResponse> {

        let url = this.hostUrl + this.convergeModelUrlPath;
        url = encodeURI(url);

        const payload = {
            modelId: value.modelId,
            iterations: value.iterations,
            resetMode: value.resetType,
            maxPrice: value.maxPrice,
            resourceCurveNumPoints: value.resourceCurveNumPoints,
            resourceCurvePriceIncrement: value.resourceCurvePriceIncrement,
            maxDegeeOfParallelism: value.numCores,
            modelNamesToRun: value.modelNamesToRun,
            logConvergenceStats: value.logConvergenceStats,
            logConvergenceRunStats: value.logConvergenceRunStats,
            userNotifications: value.userNotifications,
            scenarioNamesToRun: value.scenarioNamesToRun,
            dryRun: value.dryRun,
            comments: value.comments,
        };

        return FetchWrapper.sendCommandAndHandle(url, { method: "post", body: JSON.stringify(payload) });
    }

    /**
     * Gets the url for returning the job list
     * @returns {} 
     */
    getJobListUrl = () => {
        return this.rootApiUrl + "/indexasdt";
    }

    // Cancels a job
    cancelJob(jobId: string): Promise<IBasicCommandResponse> {
        var url = this.cancelJobUrl;
        url = encodeURI(url);

        var payload = { jobId: jobId };
        return FetchWrapper.sendCommandAndHandle(url,
            { method: "post", body: JSON.stringify(payload) });
    }

    // Aborts a job
    abortJob(jobId: string): Promise<IBasicCommandResponse> {
        var url = "/api/1.0/command/abortmodelconvergence";

        var payload = { jobId: jobId };
        return FetchWrapper.sendCommandAndHandle(url,
            { method: "post", body: JSON.stringify(payload) });
    }

    /**
     * Delete job fn
     * @param {} jobId 
     * @param {} successCallback 
     * @returns {} 
     */
    deleteJob = (jobId: string): Promise<any> => {

        var url = this.deleteJobUrl;
        url = encodeURI(url);

        var payload = { jobId: jobId };
        return $.ajax({
            type: "POST",
            data: JSON.stringify(payload),
            contentType: "application/json",
            dataType: "json",
            url: url
        });
    }

    /**
     * Gets the convergence host url
     * @param {} jobId 
     * @param {} successCallback 
     * @returns {} 
     */
    getJob = (jobId: string): Promise<any> => {

        var url = this.rootApiUrl + "/" + jobId;

        return $.ajax({
            type: "GET",
            url: url,
            global: false, // Suppress default ajax confirmation
        });
    }


}






// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.convergence-services.ts